import { Component, OnInit, ElementRef } from '@angular/core';
import { SUPERROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { Globals } from '../../_globals';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { StoreContextService } from '../../_services/store-context.service';
import { CryptoService } from '../../_services/crypto.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;

  public isCollapsed = true;
  public role: any;

  _cryptoService: CryptoService = new CryptoService();

  store: any;
  storeName: any;
  storeId: any;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    public _authService: AuthService,
    public globals: Globals,
    public activatedRoute: ActivatedRoute,
    public cookieService: CookieService,
    public _storeContextService: StoreContextService
  ) {
    const currentStoreExists = cookieService.check('currentStore');
    if (currentStoreExists) {
      this.store = JSON.parse(cookieService.get('currentStore'));
      this.storeName = this.store.name;
      this.storeId = '#' + this.store.id;
    } else {
      this.storeName = 'Select Store';
      this.storeId = '';
      // console.log('no current store cookie');
    }
    this.location = location;
    this.sidebarVisible = false;

    this.role = globals.user.role;
    this._storeContextService.storeChanged.subscribe((store) => {
      // console.log('Subscribed Store Nav ts => ', store);
      this.store = store;
      this.storeName = store.name;
      this.storeId = '#' + store.id;
    });
  }

  ngOnInit() {
    this.listTitles = SUPERROUTES.filter((listTitle) => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
      const $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }

  public storeSwitcher() {
    this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    // console.log(navbar);
    if (!this.isCollapsed) {
      navbar.classList.remove('navbar-transparent');
      navbar.classList.add('bg-white');
    } else {
      navbar.classList.add('navbar-transparent');
      navbar.classList.remove('bg-white');
    }
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    const html = document.getElementsByTagName('html')[0];
    if (window.innerWidth < 991) {
      mainPanel.style.position = 'fixed';
    }

    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    html.classList.add('nav-open');

    this.sidebarVisible = true;
  }
  sidebarClose() {
    const html = document.getElementsByTagName('html')[0];
    this.toggleButton.classList.remove('toggled');
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];

    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = '';
      }, 500);
    }
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  }
  sidebarToggle() {
    // const toggleButton = this.toggleButton;
    // const html = document.getElementsByTagName('html')[0];
    const $toggle = document.getElementsByClassName('navbar-toggler')[0];

    let $layer = null;

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const html = document.getElementsByTagName('html')[0];

    if (this.mobile_menu_visible === 1) {
      // $('html').removeClass('nav-open');
      html.classList.remove('nav-open');
      if ($layer) {
        $layer.remove();
      }
      setTimeout(function () {
        $toggle.classList.remove('toggled');
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function () {
        $toggle.classList.add('toggled');
      }, 430);

      $layer = document.createElement('div');
      $layer.setAttribute('class', 'close-layer');

      if (html.querySelectorAll('.main-panel')) {
        document.getElementsByClassName('main-panel')[0].appendChild($layer);
      } else if (html.classList.contains('off-canvas-sidebar')) {
        document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
      }

      setTimeout(function () {
        $layer.classList.add('visible');
      }, 100);

      $layer.onclick = function () {
        // asign a function
        html.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        $layer.classList.remove('visible');
        setTimeout(function () {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
      }.bind(this);

      html.classList.add('nav-open');
      this.mobile_menu_visible = 1;
    }
  }

  toolkitAccess() {
    console.log('== TOOLKIT ACCESS ==');

    // const accessToken = this.cookieService.get(environment.keys.accessToken);
    // console.log('accessToken', accessToken);

    // const savedtoken = this._cryptoService.decryptText(this.cookieService.get(environment.keys.accessToken));
    // console.log('savedtoken', savedtoken);

    window.open(environment.toolkitPortal, '_blank');
  }

  // getTitle() {
  //     let titlee = this.location.prepareExternalUrl(this.location.path());
  //     if (titlee.charAt(0) === '#') {
  //         titlee = titlee.slice(2);
  //     }
  //     titlee = titlee.split('/').pop();

  //     for (let item = 0; item < this.listTitles.length; item++) {
  //         if (this.listTitles[item].path === titlee) {
  //             return this.listTitles[item].title;
  //         }
  //     }

  //     if (titlee.indexOf('?') >= 0) {
  //         titlee = titlee.substring(0, titlee.indexOf('?'));
  //     }

  //     return titlee.replace('-', ' ');
  // }

  public logout() {
    this._authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts